module.exports = __webpack_public_path__ + "static/logos/snow-forecast__logo--icon-b49c71218d4a42050a93d7ee5cc41130.svg";